import {useSelector} from "react-redux";

export const useStripeGuard = (route) => {
    const user = useSelector(state => state.users.user)
    return user &&
        user.stripe_live_subscriptions_analytics &&
        user.stripe_live_subscriptions_analytics.length > 0;
}
